import { FC } from 'react'

import { SelectFilter, SelectProps, defaultTheme } from '@agro-club/agroclub-shared'
import { useAnalyticsContext } from 'analytics/hooks'
import { useMediaQuery } from 'react-responsive'
import { MobileFilterContainer } from '../MobileComponents/Filters/MobileFilterWrapper'

interface Props extends Omit<SelectProps, 'id'> {
  id: string
  place?: string
}

const ASelectFilter: FC<Props> = ({ id, place, value, onChange, placeholder, ...otherProps }) => {
  const { track } = useAnalyticsContext()

  const handleChange = (newValue: any, option: any) => {
    onChange?.(newValue, option)

    const eventName = `change|${id}`

    track(eventName, {
      filter: id,
      ...(place ? { place } : {}),
      value: {
        from: value,
        to: newValue,
      },
    })
  }

  const isMobile = useMediaQuery({
    query: `(max-width: ${defaultTheme.queries.mobile})`,
  })

  const FilterContainer = isMobile ? MobileFilterContainer : 'div'

  return (
    <FilterContainer label={placeholder}>
      <SelectFilter value={value} onChange={handleChange} data-testid={id} placeholder={placeholder} {...otherProps} />
    </FilterContainer>
  )
}

export default ASelectFilter
